import React from 'react';
import ArchitectureDiagram from './components/ArchitectureDiagram.js'; // Explicitly add the .js extension

function App() {
  return (
    <div className="App">
      <ArchitectureDiagram />
    </div>
  );
}

export default App;
